/* THIS FILE WAS AUTO-GENERATED. DO NOT MODIFY */
/* eslint-disable */
import * as SchemaTypes from '../../../types/graph';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetSurveyWaitingPeriodQueryVariables = SchemaTypes.Exact<{ [key: string]: never; }>;


export type GetSurveyWaitingPeriodQuery = { __typename?: 'Query', surveyWaitingPeriod: { __typename?: 'WaitingPeriod', id: string, waitingPeriod: number } };


export const GetSurveyWaitingPeriodDocument = gql`
    query GetSurveyWaitingPeriod {
  surveyWaitingPeriod {
    id
    waitingPeriod
  }
}
    `;
export function useGetSurveyWaitingPeriodQuery(baseOptions?: Apollo.QueryHookOptions<GetSurveyWaitingPeriodQuery, GetSurveyWaitingPeriodQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSurveyWaitingPeriodQuery, GetSurveyWaitingPeriodQueryVariables>(GetSurveyWaitingPeriodDocument, options);
      }
export function useGetSurveyWaitingPeriodLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSurveyWaitingPeriodQuery, GetSurveyWaitingPeriodQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSurveyWaitingPeriodQuery, GetSurveyWaitingPeriodQueryVariables>(GetSurveyWaitingPeriodDocument, options);
        }
export function useGetSurveyWaitingPeriodSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSurveyWaitingPeriodQuery, GetSurveyWaitingPeriodQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSurveyWaitingPeriodQuery, GetSurveyWaitingPeriodQueryVariables>(GetSurveyWaitingPeriodDocument, options);
        }
export type GetSurveyWaitingPeriodQueryHookResult = ReturnType<typeof useGetSurveyWaitingPeriodQuery>;
export type GetSurveyWaitingPeriodLazyQueryHookResult = ReturnType<typeof useGetSurveyWaitingPeriodLazyQuery>;
export type GetSurveyWaitingPeriodSuspenseQueryHookResult = ReturnType<typeof useGetSurveyWaitingPeriodSuspenseQuery>;
export type GetSurveyWaitingPeriodQueryResult = Apollo.QueryResult<GetSurveyWaitingPeriodQuery, GetSurveyWaitingPeriodQueryVariables>;